

























import { Component } from 'vue-property-decorator';
import { images } from '@/core/constants';
import AppVue from '@/AppVue.vue';
import AuthHeaderCpt from './components/AuthHeaderCpt.vue';

@Component({
  components: {
    AuthHeaderCpt,
  },
})
export default class LoginView extends AppVue {
  get eiLogo() {
    return images.eiLogo;
  }

  get imiLogo() {
    return images.imiLogo;
  }

  get whiteEiLogo() {
    return images.whiteEiLogo;
  }

  async login() {
    return await this.$msal.loginPhone();
  }
}
